
// Money DTO interface for API money values
export interface Money {
  amount: number;
  currency_code: string;
}

// New API Types based on ProductsController documentation
export interface PagingInfo {
  current_page: number;
  page_size: number;
  sort_column?: string;
  search_term?: string;
  sort_descending: boolean;
  total_pages?: number;
  global_search?: string;
  total_count?: number;
}

export interface StorefrontCategory {
  id: string;
  slug: string;
  name: string;
}

export interface StorefrontVariantImage {
  id: string;
  image_url: string;
  alt_text?: string;
  display_order: number;
  is_default: boolean;
}

export interface StorefrontProductVariantDetail {
  id: string;
  name: string;
  sku: string;
  is_default: boolean;
  is_active: boolean;
  display_order: number;
  weight?: number;
  retail_price_money?: Money;
  total_available_quantity: number;
  images: StorefrontVariantImage[];
}

export interface GetProductPagedResponse {
  id: string;
  name: string;
  slug: string;
  description: string;
  brand_name?: string;
  retail_price?: Money;
  tax_rate?: number;
  is_in_stock: boolean;
  image_urls: string[];
  categories: StorefrontCategory[];
}

export interface PagedResult<T> {
  items: T[];
  current_page: number;
  page_size: number;
  total_count: number;
}

export interface GetProductByIdResponse {
  id: string;
  name: string;
  slug: string;
  description?: string;
  brand_name?: string;
  unit_of_measure_code?: string;
  retail_price?: Money;
  tax_rate?: number;
  is_in_stock: boolean;
  total_available_quantity: number;
  image_urls: string[];
  categories: StorefrontCategory[];
  variants: StorefrontProductVariantDetail[];
}

// Response tip za kategorije iz /categories/children endpointa
export interface CategoryResponse {
  id: string;
  name: string;
  code: string;
  slug: string;
  parent_category_id?: string;
  parend_category_name?: string;
  products_count: number;
  image_url?: string; // URL slike kategorije
}

export interface PaginationMeta {
  current_page: number;
  page_size: number;
  total_count: number;
  total_pages: number;
}

export interface ProductVariantAttribute {
  id: string;
  product_attribute_id: string;
  product_attribute_name: string;
  product_attribute_value_id: string;
  product_attribute_value_name: string;
}

export interface ProductVariant {
  id: string;
  name: string;
  sku: string;
  barcode: string;
  retail_price_money: Money;
  weight?: number;
  is_active: boolean;
  display_order: number;
  product_id: string;
  created_on: string;
  updated_on?: string;
  total_inventory: number;
  attributes: ProductVariantAttribute[];
}

export interface ProductVariantImage {
  id: string;
  url: string;
  alt_text?: string;
  display_order: number;
}

// New Product Search Model Types
export enum ProductSortType {
  NameAsc = 1,
  NameDesc = 2,
  PriceLow = 3,
  PriceHigh = 4
}

export interface ProductQueryParameters extends PagingInfo {
  product_name: string;
  barcode: string;
  sku: string;
  brands: string[];
  category_ids: string[];
  min_price?: number;
  max_price?: number;
  only_available?: boolean;
  only_active?: boolean;
  sort_type: ProductSortType;
}